import React, { useState } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';

const SavedAnalysisModal = ({ show, onHide, onSave, isLoading }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!name.trim()) {
      setError('Please enter a name for this analysis');
      return;
    }

    onSave(name, description);
  };

  // Reset form when modal is opened
  React.useEffect(() => {
    if (show) {
      setName('');
      setDescription('');
      setError('');
    }
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop="static"
      centered
      className="dark-modal"
    >
      <Modal.Header closeButton className="dark-modal-header">
        <Modal.Title>Save Analysis</Modal.Title>
      </Modal.Header>
      <Modal.Body className="dark-modal-body">
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Analysis Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter a name for this analysis"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="dark-input"
              isInvalid={!!error}
              disabled={isLoading}
            />
            <Form.Control.Feedback type="invalid">
              {error}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Description (Optional)</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Enter optional description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="dark-input"
              disabled={isLoading}
            />
            <small className="text-muted">You can use markdown formatting in the description.</small>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className="dark-modal-footer">
        <Button variant="outline-secondary" onClick={onHide} disabled={isLoading}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={isLoading}>
          {isLoading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2"
              />
              Saving...
            </>
          ) : (
            'Save Analysis'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SavedAnalysisModal;